import type { AccessRole } from "@/types/auth";

/**
 * Mirrors shiphouse-backend kycService.EnsureApprovedForStore:
 * KYC status must be approved AND stage must be completed.
 *
 * Auth status `onboardingCompleted` is set server-side only when both are true
 * (see buildExtendedAccessRoles). Do not treat `kycStatus === "approved"` alone
 * as sufficient — that can fire before all stages are complete.
 */
export function isStoreKycApprovedForPublishing(
  store: AccessRole | null | undefined,
): boolean {
  if (!store) return false;

  if (store.onboardingCompleted) {
    return true;
  }
  console.log("=>>>>>>>", store);

  return store.kycStage === "approved" && store.kycStatus === "completed";
}
